import { Toast } from 'vant'
class Question {
  constructor(options) {
    this.init(options)
  }
  init(options) {
    for (let i in options) {
      this[i] = options[i]
    }
    this.questionIndex = 0
    this.canNext = false //下一题
    this.finished = false //是否已经完成
    this.IndexObj = {} //保存问卷id对应的index  方便查找
    /* 设置主题色 */
    this.theme = {
      btnColor: this.btn_color || '#524485',
      checkColor:
        this.check_color || 'linear-gradient(180deg, #CDC4FF 0%, #9F91FE 100%)',
      notCheckColor: '#F5F6FA',
      stepColor: this.step_color || 'rgba(201, 187, 255, 1)'
    }

    if (Array.isArray(this.question)) {
      /*  */
      this.question.map((item, index) => {
        this.IndexObj[item.id] = index
        item.selectTip = ''
        /* 多选框类型时value初始化为数组 */
        item.value = item.que_type == 1 ? [] : ''
        /* 刻度尺信息初始化 */
        item.default_value = item.default_value || ''
        item.max_num = item.max_num || 300
        item.min_num = item.min_num || 0
        item.step_num = item.step_num || 0.1
        if (item.default_value) {
          item.value = item.default_value
        }
        /* 题目关联逻辑 */
        this.initRelationItem(item)
        /* 如果选项中需要输入框 */
        if (item.options && Array.isArray(item.options)) {
          item.options.map((item1) => {
            if (item1.que_answer_attr) {
              item1.inputValue = ''
            }
          })
        }
      })
    }
    let isJump = this.getQuestion(options.question)
    if (isJump) {
      this.update()
    } else {
      this.jumpFirstQuestion()
    }
  }
  /* 跳转到第一个题目 */
  jumpFirstQuestion() {
    if (this.question[this.questionIndex].que_type === 7 && !this.finished) {
      this.canNext = true
      if (this.questionIndex >= this.question.length - 1) {
        return
      }
      setTimeout(() => {
        this.next()
      }, 1100)
    }
  }
  //如果当前不是题目则过一秒自动跳过

  initRelationItem(item) {
    if (
      item.other_rule &&
      Array.isArray(item.other_rule) &&
      item.other_rule.length
    ) {
      item.is_show = 0
      let res = {}
      res.type = item.other_rule[0].type
      res.list = []
      res.select = []
      let obj = {}
      for (let i = 0; i < item.other_rule.length; i++) {
        if (obj[item.other_rule[i].subject_id]) {
          if (
            !obj[item.other_rule[i].subject_id].answer_id.includes(
              item.other_rule[i].answer_id
            )
          ) {
            obj[item.other_rule[i].subject_id].answer_id.push(
              item.other_rule[i].answer_id
            )
          }
        } else {
          obj[item.other_rule[i].subject_id] = {
            answer_id: [item.other_rule[i].answer_id],
            judge_type: item.other_rule[i].judge_type,
            subject_id: item.other_rule[i].subject_id
          }
        }
      }
      for (let key in obj) {
        res.list.push(obj[key])
      }
      item.other_rule = res
      for (let i = 0; i < item.other_rule.list.length; i++) {
        let questionIndex = this.IndexObj[item.other_rule.list[i].subject_id]
        let questionItem = this.question[questionIndex]
        if (questionItem) {
          if (questionItem.relationIndex) {
            questionItem.relationIndex.push(this.IndexObj[item.id])
          } else {
            questionItem.relationIndex = [this.IndexObj[item.id]]
          }
        }
      }
    }
  }
  //上一题
  pre() {
    for (let i = this.questionIndex - 1; i >= 0; i--) {
      if (this.question[i].is_show && this.question[i].que_type !== 7) {
        this.jumpQuestion(i)
        break
      }
    }
    this.update()
  }
  //下一题
  next() {
    if (!this.canNext) {
      return
    }
    let questionIndex = this.isNeedJumpQueston()
    if (questionIndex !== undefined) {
      if (this.question[questionIndex].is_show) {
        this.jumpQuestion(questionIndex)
      } else {
        let jumpIndex = this.findNextQuestion()
        this.jumpQuestion(jumpIndex)
      }
    } else {
      let jumpIndex = this.findNextQuestion()
      this.jumpQuestion(jumpIndex)
    }
    this.update()
    this.jumpFirstQuestion()
    this.saveQuestion()
  }
  /* 找到下个题目的index */
  findNextQuestion() {
    for (let i = this.questionIndex + 1; i < this.question.length; i++) {
      if (this.question[i].is_show) {
        return i
      }
    }
  }
  updateRelation() {
    let item = this.question[this.questionIndex]
    if (item.relationIndex) {
      for (let i = 0; i < item.relationIndex.length; i++) {
        let questionItem = this.question[item.relationIndex[i]]
        if (questionItem.other_rule) {
          questionItem.other_rule.list.map((ruleItem) => {
            if (ruleItem.subject_id == item.id) {
              let values = Array.isArray(item.value) ? item.value : [item.value]
              let isFound = false
              switch (ruleItem.judge_type) {
                case 1:
                  for (let j = 0; j < values.length; j++) {
                    if (ruleItem.answer_id.includes(values[j])) {
                      isFound = true
                    }
                  }
                  break
                case 2:
                  isFound = true
                  for (let j = 0; j < ruleItem.answer_id.length; j++) {
                    if (!values.includes(ruleItem.answer_id[j])) {
                      isFound = false
                      break
                    }
                  }
                  break
              }
              if (isFound) {
                if (!questionItem.other_rule.select.includes(item.id)) {
                  questionItem.other_rule.select.push(item.id)
                }
              } else {
                let arrIndex = questionItem.other_rule.select.indexOf(item.id)
                if (arrIndex >= 0) {
                  questionItem.other_rule.select.splice(arrIndex, 1)
                }
              }
              /*  */
              let show = false
              switch (questionItem.other_rule.type) {
                case 1:
                  questionItem.other_rule.list.map((listItem) => {
                    if (
                      questionItem.other_rule.select.includes(
                        listItem.subject_id
                      )
                    ) {
                      show = true
                    }
                  })
                  break
                case 2:
                  show = true
                  questionItem.other_rule.list.map((listItem) => {
                    if (
                      !questionItem.other_rule.select.includes(
                        listItem.subject_id
                      )
                    ) {
                      show = false
                    }
                  })
                  break
              }
              questionItem.is_show = show ? 1 : 0
            }
          })
        }
      }
    }
  }
  change() {
    /* 更新题目关联逻辑 */
    this.updateRelation()
    this.updateTips()
    this.updateJump()
    this.updateFinished()
    this.updateQuestion()
    this.autoNext()
  }
  update() {
    this.updateJump()
    this.updateFinished()
    this.updateQuestion()
  }
  /* 自动下个题目 */
  autoNext() {
    /* 最后一题不自动跳转下一题 */
    if (this.questionIndex >= this.question.length - 1) {
      return
    }
    /* 单选则自动下一题 */
    if (
      this.canNext &&
      this.question[this.questionIndex].que_type == 0 &&
      !this.question[this.questionIndex].selectTip
    ) {
      let attrKey
      this.question[this.questionIndex].options.map((item) => {
        if (item.que_answer_attr) {
          attrKey = item.key
        }
      })
      if (this.question[this.questionIndex].value !== attrKey) {
        setTimeout(() => {
          this.next()
        }, 600)
      }
    }
  }
  //更新提示
  updateTips() {
    if (this.question[this.questionIndex].que_type == 0) {
      let tip = ''
      this.question[this.questionIndex].options.map((item) => {
        if (item.key == this.question[this.questionIndex].value) {
          tip = item.que_answer_tips
        }
      })
      this.question[this.questionIndex].selectTip = tip
    } else if (this.question[this.questionIndex].que_type == 1) {
      let tip = []
      this.question[this.questionIndex].options.map((item) => {
        if (this.question[this.questionIndex].value.includes(item.key)) {
          tip.push(item.que_answer_tips)
        }
      })
      this.question[this.questionIndex].selectTip = tip
    }
  }
  //更新问卷结束状态
  updateFinished() {
    if (this.questionIndex >= this.question.length - 1) {
      let cur = this.question[this.questionIndex]
      if (
        (Array.isArray(cur.value) && !cur.value.length) ||
        (!Array.isArray(cur.value) && !cur.value && cur.que_type != 7)
      ) {
        this.finished = false
      } else {
        this.finished = true
        this.canNext = false
      }
    } else {
      for (let i = this.questionIndex + 1; i < this.question.length; i++) {
        if (this.question[i].que_type == 7) {
          this.finished = false
          return
        }
        if (this.question[i].is_show) {
          this.finished = false
          return
        }
      }
      this.finished = true
      this.canNext = false
    }
  }
  //更新是否可以跳转下一题
  updateJump() {
    if (this.questionIndex >= this.question.length - 1) {
      this.canNext = false
      return
    }
    let cur = this.question[this.questionIndex]
    /* 选项必须 */
    if (cur.is_required) {
      /* 未选中选项 */
      if (
        (Array.isArray(cur.value) && !cur.value.length) ||
        (!Array.isArray(cur.value) && cur.value === '')
      ) {
        this.canNext = false
      } else {
        /* 选中选项 再判断每个选项中的输入框是否是必填以及是否填写 */
        switch (cur.que_type) {
          /* 单选 */
          /*  case 0:
                         for (let i = 0; i < cur.options.length; i++) {
                             let item = cur.options[i];
                             if (cur.value === item.key) {
                                 if (item.que_answer_attr) {
                                     this.canNext = false;
                                 } else {
                                     this.canNext = true;
                                 }
                             }
                         }
                         break; */
          /* 多选 */
          /*  case 1:
                         for (let i = 0; i < cur.options.length; i++) {
                             let item = cur.options[i];
                             if (cur.value.includes(item.key)) {
                                 if (item.input && item.input.is_required && !item.input.value) {
                                     this.canNext = false;
                                     return
                                 }
                             }
                         }
                         this.canNext = true;
                         break; */
          /* 问答 */
          case 2:
            if (cur.value) {
              this.canNext = true
            } else {
              this.canNext = false
            }
            break
          default:
            this.canNext = true
        }
      }
    } else {
      this.canNext = true
    }
  }
  //根据id获取问卷的index
  getQuestionIndex(id) {
    for (let i = 0; i < this.question.length; i++) {
      if (this.question[i].id == id) {
        return i
      }
    }
  }
  //更新问卷隐藏显示状态
  updateQuestion() {
    let cur = this.question[this.questionIndex]
    /*  */
    let radioTypeList = [0, 4] //单选形式
    let checkboxTypeList = [1] //多选形式
    /*  */
    /* 单选 */
    if (radioTypeList.includes(cur.que_type)) {
      cur.options.map((item) => {
        if (cur.value === item.key) {
          if (item.jumpId) {
            /* 先还原后面所有隐藏的题目 */
            for (
              let i = this.questionIndex + 1;
              i < this.question.length;
              i++
            ) {
              if (!this.question[i].other_rule) {
                this.question[i].is_show = 1
              }
            }
            /* 再隐藏该题到跳转题之间的题目 */
            let jumpIndex = this.getQuestionIndex(item.jumpId)
            for (let i = this.questionIndex + 1; i < jumpIndex; i++) {
              this.question[i].is_show = 0
            }
          } else {
            this.finished = true
            this.canNext = false
          }
        }
      })
    } else if (checkboxTypeList.includes(cur.que_type)) {
      /* 多选 */
      for (let i = 0; i < cur.options.length; i++) {
        let item = cur.options[i]
        if (cur.value.includes(item.key)) {
          if (item.jumpId) {
            /* 先还原后面所有隐藏的题目 */
            for (
              let i = this.questionIndex + 1;
              i < this.question.length;
              i++
            ) {
              if (!this.question[i].other_rule) {
                this.question[i].is_show = 1
              }
            }
            /* 再隐藏该题到跳转题之间的题目 */
            let jumpIndex = this.getQuestionIndex(item.jumpId)
            for (let i = this.questionIndex + 1; i < jumpIndex; i++) {
              this.question[i].is_show = 0
            }
          } else {
            this.finished = true
            this.canNext = false
          }
          return
        }
      }
    } else {
      if (cur.options[0]) {
        let jumpId = cur.options[0].jumpId
        if (jumpId) {
          /* 先还原后面所有隐藏的题目 */
          for (let i = this.questionIndex + 1; i < this.question.length; i++) {
            if (!this.question[i].other_rule) {
              this.question[i].is_show = 1
            }
          }
          /* 再隐藏该题到跳转题之间的题目 */
          let jumpIndex = this.getQuestionIndex(jumpId)
          for (let i = this.questionIndex + 1; i < jumpIndex; i++) {
            this.question[i].is_show = 0
          }
        } else {
          this.finished = true
          this.canNext = false
        }
      }
    }
  }
  //是否需要跳转题目 返回需要跳转的questionIndex
  isNeedJumpQueston() {
    let jumpId
    let questionIndex
    let optionsType = [0, 1, 4] //单选、多选、下拉
    let item = this.question[this.questionIndex]
    if (optionsType.includes(item.que_type)) {
      if (Array.isArray(item.options)) {
        item.options.map((item1) => {
          if (item1.key === item.value) {
            jumpId = item1.jumpId
          }
        })
      }
    } else {
      if (
        Array.isArray(item.options) &&
        item.options.length >= 1 &&
        item.options[0].jumpId
      ) {
        jumpId = item.options[0].jumpId
      }
    }
    if (jumpId !== undefined) {
      this.question.map((item, index) => {
        if (item.id === jumpId) {
          questionIndex = index
        }
      })
    }
    return questionIndex
  }
  getResult() {
    let res = []
    this.question.map((item) => {
      if (
        (!Array.isArray(item.value) && item.value !== '') ||
        (Array.isArray(item.value) && item.value.length)
      ) {
        if (!item.is_show) {
          return
        }
        let obj = {
          subject_id: item.id,
          info: []
        }
        /* 单选多选 */
        if (item.que_type == 0 || item.que_type == 1) {
          let arr = []
          let answer = Array.isArray(item.value) ? item.value : [item.value]
          item.options.map((item1) => {
            if (answer.includes(item1.key)) {
              arr.push({
                value: item1.key,
                // que_type: item.que_type,
                explain: item1.inputValue || '',
                que_filed: item.que_filed
              })
            }
          })
          obj.info = arr
          res.push(obj)
        } else {
          /* 其他 */
          obj.info = [
            {
              value: item.value,
              explain: '',
              que_filed: item.que_filed
            }
          ]
          res.push(obj)
        }
      }
    })
    return res
  }
  //跳转指定题目
  jumpQuestion(questionIndex) {
    if (
      questionIndex !== undefined &&
      questionIndex >= 0 &&
      questionIndex <= this.question.length - 1
    ) {
      this.questionIndex = questionIndex
    } else {
      Toast('不存在跳转的题目')
    }
  }
  //隐藏题目
  hideQuestion() {}
  //显示题目
  showQuestin() {}
  //计算分数
  computedScore(elId) {
    let score = 0
    this.question.map((item) => {
      if (item.que_type == 0) {
        item.options.map((optionItem) => {
          if (optionItem.key == item.value && optionItem.element_data) {
            optionItem.element_data.map((elItem) => {
              if (elItem.element_id == elId) {
                score += elItem.score
              }
            })
          }
        })
      } else if (item.que_type == 1) {
        item.options.map((optionItem) => {
          if (item.value.includes(optionItem.key) && optionItem.element_data) {
            optionItem.element_data.map((elItem) => {
              if (elItem.element_id == elId) {
                score += elItem.score
              }
            })
          }
        })
      }
    })
    return score
  }
  //保存问卷进度
  saveQuestion() {
    let data = {}
    data.questionIndex = this.questionIndex
    data.canNext = this.canNext
    data.finished = this.finished
    data.question = this.question
    localStorage.setItem('joinCampQuestionSaved', JSON.stringify(data))
  }
  //清空问卷保存
  clearQuestion() {
    localStorage.removeItem('joinCampQuestionSaved')
  }
  //获取当前问卷进度 返回是否应用保存数据
  getQuestion(curQuestionData) {
    let historyData = localStorage.getItem('joinCampQuestionSaved')
    if (historyData) {
      historyData = JSON.parse(historyData)
      let isChange = this.compareQuestion(historyData.question, curQuestionData)
      if (!isChange) {
        this.questionIndex = historyData.questionIndex
        this.canNext = historyData.canNext
        this.finished = historyData.finished
        this.question = historyData.question
      }
      return !isChange
    } else {
      return false
    }
  }
  //对比问卷是否发生变化
  compareQuestion(oldQuestion, newQuestion) {
    if (oldQuestion.length != newQuestion.length) {
      return true
    }
    for (let i = 0; i < oldQuestion.length; i++) {
      let oldItem = oldQuestion[i]
      let newItem = newQuestion[i]
      let queTypeArr = ['camp_que_from', 'camp_phone']
      //判断某些特定的选择值是否发生变化
      if (
        queTypeArr.includes(oldItem.que_filed) &&
        oldItem.value != newItem.value
      ) {
        return true
      }
      //判断题目是否发生变化
      if (
        oldItem.id != newItem.id ||
        oldItem.que_type != newItem.que_type ||
        oldItem.options.length != newItem.options.length
      ) {
        return true
      }
      //判断选项是否发生变化
      for (let j = 0; j < oldItem.options.length; j++) {
        let oldOptionsItem = oldItem.options[j]
        let newOptionsItem = newItem.options[j]
        if (oldOptionsItem.key != newOptionsItem.key) {
          return true
        }
      }
    }
    return false
  }
}
export { Question }
